import { Alert, CircularProgress, Divider, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { type HttpError } from "@refinedev/core";
import { useUpdateWithInfiniteListInvalidation } from "hooks/useUpdateWithInfiniteListInvalidation";
import {
} from "interfaces/contribution-transaction";
import { IGrantRequest, IScheduledGrantRequest } from "interfaces/grant-requests";
import { useState } from "react";

interface ModalProps {
  visible: boolean;
  data: {
    grantRequest: IGrantRequest | undefined
    scheduledGrantRequest: IScheduledGrantRequest | undefined;
    value: "PENDING" | "PROCESSED";
  };
  close: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: () => void;
}
export const EvaluateScheduledGrantRequestModal: React.FC<ModalProps> = ({
  visible,
  close,
  data,
  refresh
}) => {

  const [pendingRequestError, setPendingRequestError] = useState("");
  const [executionDate, setExecutionDate] = useState({
    value: new Date().toISOString().substring(0, 10),
    error: false,
  });
  const { mutate, isLoading } = useUpdateWithInfiniteListInvalidation();
  return (
    <Dialog open={visible} onClose={() => close(false)}>
      <DialogTitle color="primary">

        Process this user grant request transaction
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography>
          Are you sure you want to{" "}
          Process this user
          grant request transaction?
        </Typography>
        <TextField
          id="executionDate"
          name="executionDate"
          error={executionDate.error}
          helperText={
            executionDate.error && "The date is required, and cannot be negative value!"
          }
          defaultValue={executionDate.value}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="date"
          label="Execution Date"
          onChange={(event: any) => {
            setExecutionDate({
              value: event.target.value,
              error: false,
            });
          }} />
        {
          pendingRequestError !== "" && (
            <Alert sx={{
              mt: 1
            }} severity="error">{pendingRequestError}.</Alert>
          )
        }
      </DialogContent>
      <Divider />
      <DialogActions>
        <>
          <Button
            disabled={isLoading}
            startIcon={
              isLoading && <CircularProgress size={20} color="inherit" />
            }
            variant="contained"
            onClick={() => {
              setPendingRequestError("")
              mutate(
                {
                  resource: "grant-requests",
                  values: {
                    status: data.value,
                    executionDate: executionDate.value,
                  }
                  ,
                  id: `${data.grantRequest?.grantRequestId as any}/scheduledGrantRequests/${data.scheduledGrantRequest?.scheduledGrantRequestId as any}/status`,
                },
                {
                  onSuccess: () => {
                    refresh();
                    close(false);
                  },
                  onError: (error: HttpError) => {
                    setPendingRequestError(error.message);
                  },
                }
              );

            }}
          >
            Confirm
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              close(false);
            }}
          >
            Cancel
          </Button>
        </>
      </DialogActions>
    </Dialog>
  );
};
